var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.294,
    height: 40.701,
    viewBox: "0 0 36.294 40.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_79034",
    "data-name": "Path 79034",
    d: "M99.416,95.043a9.127,9.127,0,0,0-3.72-1.654L89.074,92.11a1.452,1.452,0,0,1-1.2-1.425V89.223a17.291,17.291,0,0,0,1.247-2.14,11.65,11.65,0,0,1,1.063-1.794,9.467,9.467,0,0,0,3.038-4.631,4.323,4.323,0,0,0-.426-3.431,24.821,24.821,0,0,0-.516-5.876c-.054-2.291-.486-3.579-1.573-4.707a4.765,4.765,0,0,0-2.805-1.134,5.058,5.058,0,0,1-1.03-.233A10.98,10.98,0,0,0,81.776,64c-3.977.157-8.866,2.593-10.5,6.937a15.907,15.907,0,0,0-.414,5.239l-.039,1.049a4.505,4.505,0,0,0-.4,3.431,9.451,9.451,0,0,0,3.059,4.654,12.652,12.652,0,0,1,1.06,1.785A17.9,17.9,0,0,0,75.8,89.226v1.462a1.459,1.459,0,0,1-1.2,1.425L67.97,93.392a9.147,9.147,0,0,0-3.708,1.651,1.449,1.449,0,0,0-.565,1.023,1.42,1.42,0,0,0,.387,1.093,24.672,24.672,0,0,0,35.51,0,1.415,1.415,0,0,0,.387-1.1A1.438,1.438,0,0,0,99.416,95.043Z",
    transform: "translate(-63.693 -64)",
    fill: "#bcbcbc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultIcon);
export default __webpack_public_path__ + "static/media/user-default-icon.866fc53cdda906bbbf87978ae21f9122.svg";
export { ForwardRef as ReactComponent };